import { Routes, Route } from 'react-router-dom'
import Sidebar from '@/core/components/globals/sidebar'
import Content from '@/core/components/globals/content'
import NotificationProvider from '@/providers/notification/provider'
import RealtimeExchangeProvider from '@/providers/realtime-exchange/provider'
import { lazy, Suspense } from 'react'
import Loading from '@/core/components/globals/loading'

const Index = lazy(() => import('@/pages/Index'))
const AboutUs = lazy(() => import('@/pages/AboutUs'))
const OnBoarding = lazy(() => import('@/pages/OnBoarding'))
const MainAccount = lazy(() => import('@/pages/MainAccount'))
const Exchange = lazy(() => import('@/pages/Exchange'))
const DcaStrategy = lazy(() => import('@/pages/DcaStrategy'))
const ManagementMandate = lazy(() => import('@/pages/ManagementMandate'))
/* TODO - Treasury */
// const Treasury = lazy(() => import('@/pages/Treasury'))
const Preference = lazy(() => import('@/modules/preferences/content'))

export default function AppLayout() {
  // Get user ID from environment variable for WebSocket subscription
  const userId = import.meta.env.VITE_DATA_PLATFORM_USER_ID

  return (
    <div className="desktop-device">
      <NotificationProvider>
        <RealtimeExchangeProvider userId={userId} />
        <Sidebar />
        <Content>
          <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Loading /></div>}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/main-account/*" element={<MainAccount />} />
              <Route path="/exchange/*" element={<Exchange />} />
              <Route path="/dca-strategy/*" element={<DcaStrategy />} />
              <Route path="/management-mandate/*" element={<ManagementMandate />} />
              {/* TODO - Treasury */}
              {/*<Route path="/treasury/*" element={<Treasury />} />*/}
              <Route path="/about-us/*" element={<AboutUs />} />
              <Route path="/on-boarding/*" element={<OnBoarding />} />
              <Route path="/user-preferences" element={<Preference />} />
            </Routes>
          </Suspense>
        </Content>
      </NotificationProvider>
    </div>
  )
}
